import { BrowserRouter as Router, Switch } from 'react-router-dom'
import './App.scss'
import './assets/scss/main.scss'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import persistStore from 'redux-persist/es/persistStore'

// eslint-disable-next-line import/no-extraneous-dependencies
import { StyledEngineProvider } from '@mui/styled-engine'
import { createTheme, ThemeProvider } from '@mui/material'
import store from './store'
import Configuration from './Configuration'
import AppRouting from './routes/app-routing'

const theme = createTheme()

function App() {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Router>
                    <Switch>
                        {/* admin section */}
                        <Provider store={store}>
                            <PersistGate
                                loading={null}
                                persistor={persistStore(store)}
                            >
                                <Configuration />
                                <>
                                    <AppRouting />
                                </>
                            </PersistGate>
                        </Provider>
                    </Switch>
                </Router>
            </ThemeProvider>
        </StyledEngineProvider>
    )
}

export default App
